module.exports = __webpack_public_path__ + "static/how-to-read-a-book-a771261524ddb61f80bf14c1c4135bbb.jpg";